import { defineComponent as _defineComponent } from 'vue'
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { biClick } from '@tencent/fit-bi-sdk';
import { computed, onMounted, ref } from 'vue';
import { getUrlParamByKey, UrlParamKey } from '../../../utils/url-params-helper';
import { VITASOY_LOTTERY_DIALOG } from '@/config/dialog-manager-config';
import { useDialogManager } from '@/hooks/use-dialog-manager';
import { ModuleName } from '@/types/module-config';
import { showToast, ToastType } from '@tencent/wphk-components-toast';
import { ExecLotteryResultText } from './config/exec-config';
// 组件导入
import LotteryBanner from './components/lottery-banner.vue';
import GetPrizeDialog from './components/get-prize-dialog.vue';
import LotteryInfoDialog from './components/lottery-info-dialog.vue';

// 配置和工具导入
import { useVitasoyLottery, BannerStatus } from './hooks/use-vitasoy-lottery';
import { to, url } from '@tencent/wphk-base-utils';
import { INFO_DIALOG_CONFIG, LOTTERY_BANNER, NOT_ALLOW_ADTAGS } from './config';
import { preloadImages } from '@/utils/preload';
import { PRIZE_BATCH_IMAGE_MAP } from './config/prize-config';

// 获取 URL 参数

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['initDone'],
  setup(__props, { emit }) {

const cdkey = getUrlParamByKey(UrlParamKey.cdkey);

// 使用抽奖 composable
const { isActStart, bannerStatus, executeAutoLottery } = useVitasoyLottery({ cdkey });


// Dialog 管理
const { showWithDialogManager, hideWithDialogManager } = useDialogManager();

// Refs
const lotteryInfoDialog = ref();
const getPrizeDialog = ref();

/**
 * cdkey 是否存在的埋点标识
 * 用于埋点上报，标识用户是否通过 cdkey 链接访问
 */
const hasCdkey = computed(() => (cdkey ? '1' : '0'));
// 往期活动的adtag不展示
const isNotAllowAdtag = computed(() => NOT_ALLOW_ADTAGS.includes(url.getUrlAdtag() || ''));

/**
 * Banner 点击处理 - 根据状态分发行为
 */
const onClickBanner = () => {
  // 埋点上报
  biClick('vitasoy-lottery-2601.banner_click|Banner点击', {
    fstatus: bannerStatus.value,
    fcdkey: hasCdkey.value,
  });

  switch (bannerStatus.value) {
    case BannerStatus.Won:
      // 已中奖 → 跳转优惠券列表
      jumpPage.goMyCoupons({ adtag: 'vitasoy2601' });
      break;

    case BannerStatus.Ended:
      // 已结束 → 拉起规则半屏（仅查看）
      lotteryInfoDialog.value.showDialog();
      break;

    case BannerStatus.Ongoing:
    default:
      // 进行中（未中奖）→ 拉起规则半屏
      lotteryInfoDialog.value.showDialog();
      break;
  }
};

/**
 * Footer 活动规则链接点击
 */
const onClickRuleLink = () => {
  lotteryInfoDialog.value.showDialog();
};

/**
 * 隐藏中奖弹窗回调
 */
const onHideVitasoyDialog = hideWithDialogManager(VITASOY_LOTTERY_DIALOG, () => {
  console.log('====hide vitasoy lottery dialog');
});

const handleLottery = showWithDialogManager(VITASOY_LOTTERY_DIALOG, async () => {
  console.log('====show vitasoy lottery dialog');
  const [err, res] = await to(executeAutoLottery());
  if (err) {
    showToast({
      title: err?.retcode && ExecLotteryResultText[err.retcode] ? ExecLotteryResultText[err.retcode] : '抽獎失敗',
      type: ToastType.Empty,
      className: 'lottery-toast',
    });
    onHideVitasoyDialog();
    return;
  }
  if (res) {
    const { prizeId, userCoupon } = res;
    // 显示中奖弹窗
    getPrizeDialog.value?.showDialog({
      prizeId,
      userCouponId: userCoupon?.[0]?.userCouponId,
      couponType: userCoupon?.[0]?.couponType,
    });
  }
});

onMounted(async () => {
  if (!isNotAllowAdtag.value && isActStart.value) {
    handleLottery();
  }
  emit('initDone', { moduleName: ModuleName.VitasoyLotteryModule });
  preloadImages([
    LOTTERY_BANNER,
    ...Object.values(PRIZE_BATCH_IMAGE_MAP).flat(),
    INFO_DIALOG_CONFIG.picture,
  ]);
});

return { __sfc: true,cdkey, isActStart, bannerStatus, executeAutoLottery, emit, showWithDialogManager, hideWithDialogManager, lotteryInfoDialog, getPrizeDialog, hasCdkey, isNotAllowAdtag, onClickBanner, onClickRuleLink, onHideVitasoyDialog, handleLottery, LotteryBanner, GetPrizeDialog, LotteryInfoDialog }
}

})